import { EnumQuoteType } from "../enum/enum-quote-type";

export class ProductSearchRequest {
    constructor(
                public country: string,
                public role: string,
                public service: string,
                public searchParam?: string,
                public extinctionArticlesIncluded?: boolean,
                public type?: EnumQuoteType,
                public cmcProtocolCode?: string,
                public elisCodeList?: string[],
                ) {
    }
}
